"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { tools } from "@/lib/tools-registry"
import { useTools } from "./tools-context"

export function ToolRouteTracker() {
  const pathname = usePathname()
  const { addToRecent, isHydrated } = useTools()

  useEffect(() => {
    if (!isHydrated) return

    const activeTool = tools.find(
      (tool) =>
        pathname === tool.href || pathname.startsWith(`${tool.href}/`)
    )

    if (activeTool) {
      addToRecent(activeTool.id)
    }
  }, [addToRecent, isHydrated, pathname])

  return null
}
